document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.strikeman-market-selector__form')) return;

    const selector = form.closest('.strikeman-market-selector');
    const previewThemeId =
      new URLSearchParams(window.location.search).get('preview_theme_id') ||
      (selector?.dataset.themeRole !== 'main' ? selector?.dataset.themeId : '');
    if (!previewThemeId) return;

    const submitter = event.submitter;
    if (!(submitter instanceof HTMLButtonElement)) return;

    const previewOrigin = submitter.dataset.previewOrigin;
    if (!previewOrigin) return;

    event.preventDefault();

    const previewUrl = new URL(window.location.pathname, previewOrigin);
    previewUrl.searchParams.set('preview_theme_id', previewThemeId);
    window.location.assign(previewUrl.toString());
  },
  true
);
